
export function armaMailAdmin({ dataClienteOriginal, dataNuevoCliente }, id_cliente_nuevo, url) {
    const mail = `
<div style="font-family: Arial, sans-serif; font-size: 15px; color: #333;">
  <p style="color: #333;"><strong>📝 Cambio de titularidad pendiente de revisión</strong></p>

  <p style="color: #333;">Se ha solicitado un cambio de titularidad en el sistema.</p>
  <p style="color: #333;">
    <strong>Usuario que solicita el cambio:</strong><br>
    ${dataNuevoCliente.usuario}
  </p>


  <p style="color: #333;">
    <strong>Cliente actual:</strong><br>
    ${dataClienteOriginal.razon_social}
  </p>

  <p style="color: #333;">
    <strong>Nuevo titular propuesto:</strong><br>
    ${dataNuevoCliente.razon_social}
  </p>

  <p style="color: #333;">
    Para aprobar el cambio de titularidad y dar de alta al nuevo cliente, por favor haga clic en el siguiente botón:
  </p>

  <p style="margin-top: 20px;">
    <a href="${url}"
       style="display: inline-block; padding: 10px 20px; background-color: #1976d2; color: #fff !important; text-decoration: none; border-radius: 5px; font-weight: bold;">
      ✅ Aprobar cambio de titularidad
    </a>
  </p>
</div>

`
    return mail;
}

export function armaMailGranel({ dataClienteOriginal, dataNuevoCliente }, id_cliente_nuevo) {
    const mail = `
<div style="font-family: Arial, sans-serif; font-size: 15px; color: #333;">
  <p style="color: #333;"><strong>📥 Solicitud de cambio de titularidad registrada</strong></p>

  <p style="color: #333;">Se ha solicitado un nuevo cambio de titularidad en el sistema.</p>

    <p style="color: #333;">
    <strong>Usuario que solicita el cambio:</strong><br>
    ${dataNuevoCliente.usuario}
  </p>


  <p style="color: #333;">
    <strong>Cliente original:</strong><br>
    ${dataClienteOriginal.razon_social}
  </p>

  <p style="color: #333;">
    <strong>Nuevo titular propuesto:</strong><br>
    ${dataNuevoCliente.razon_social}
  </p>

  <p style="color: #333;">
    📌 Esta solicitud ha sido enviada al área administrativa para su revisión y aprobación.
  </p>
</div>


`
    return mail;
}

export function armaMailSolicitudAprobada({ dataClienteOriginal, dataNuevoCliente }, id_cliente_nuevo) {
    const mail = `
<div style="font-family: Arial, sans-serif; font-size: 15px; color: #333;">
  <p style="color: #333;"><strong>✅ Cambio de titularidad aprobado</strong></p>

  <p style="color: #333;">
    El cambio de titularidad solicitado ha sido aprobado por el sector administrativo.
  </p>

  <p style="color: #333;">
    <strong>Antiguo titular:</strong><br>
    ${dataClienteOriginal.razon_social} (${dataClienteOriginal.sisven_id})
  </p>

  <p style="color: #333;">
    <strong>Nuevo titular:</strong><br>
    ${dataNuevoCliente.razon_social} (${dataNuevoCliente.sisven_id})
  </p>

  <p style="color: #333;">
    <strong>Se deja constancia de que el titular anterior, ${dataClienteOriginal.razon_social} (ID: ${dataClienteOriginal.sisven_id}), ha sido inactivado en el sistema. El nuevo titular ya se encuentra activo y habilitado para la carga de pedidos y demás gestiones correspondientes.</strong>
  </p>

</div>


`
    return mail;
}